module.exports = __webpack_public_path__ + "static/media/half-rectanguler.90ef1456.svg";